// @ts-nocheck TODO: type issues need to be fixed in this file
export default (hash) => Object.keys(hash || {}).map((key) => hash[key]);
